module.exports = __webpack_public_path__ + "static/img/enbidBnnaer.ac1518f.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/bidding/enbidBnnaer.png
// module id = Rf8r
// module chunks = 0